module.exports = __webpack_public_path__ + "img/P2-C8.401d2cdd.svg";